<nz-layout style="background-color: white">
  <div style="display: flex;background-color: inherit">
    <nz-sider
      [nzCollapsedWidth]="0"
      nzCollapsible
      [(nzCollapsed)]="isCollapsed"
      [nzTrigger]="null"
      class="sideMenu"
      nzBreakpoint="lg"
      style="display: table-column;"
    >
      <ul
        nz-menu
        nzMode="inline"
        nzCollapsible
        [nzInlineCollapsed]="isCollapsed"
        nzTheme="light"
      >
        <li style="text-align: center; margin-top: 20px;">
          <button
            nz-button
            nzType="primary"

            (click)="onCompose()"
            style="width: 75%;"
          >
          <i nz-icon nzType="plus" nzTheme="outline"></i>
            Compose
          </button>
        </li>
        <li nz-menu-item class="sideLink" *ngFor="let item of folders">
          <a
          (click)="onNavigateFolder(item.Name)"
          >
          <nz-badge [nzCount]="item.Amount" class="messageBadge">
              <span nz-typography>
                <i class=" far fas fa  {{ item.Icon }}"></i>
                {{ item.Name }}
              </span>
            </nz-badge>
            </a>
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item class="sideLink">
          <a class="sideLink" (click)="showModal()">
            <span nz-typography> New Folder </span>
          </a>
        </li>
      </ul>
    </nz-sider>
    <div style="display: table-column;max-width: 100%;overflow-x: hidden;width: 100%;">
      <router-outlet></router-outlet>
    </div>
  </div>
</nz-layout>

<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="Create new folder"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
>
  <ng-container *nzModalContent>
    <input
      nz-input
      placeholder="Folder name..."
      nzSize="large"
      [(ngModel)]="newFolderName"
    />
  </ng-container>
</nz-modal>
